import {ValidatorFn} from '@angular/forms';

export interface FormValidator {

  getValidator(): ValidatorFn;

}
